// 正式
module.exports = {
    title: 'CC规则配置',
    baseUrl: '', // 正式项目地址
    APPID: 'xxx',
    APPSECRET: 'xxx',
    $cdn: ''
}